import * as React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider
} from '@material-ui/core';

import { useServiceClient, usePreferences } from '../../contexts';
import { CatalogEntry } from '../../../lib/serviceClient';

const styles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1)
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    textarea: {
        resize: "vertical"
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }
}));

export function TableDataAccessComponent() {
    const classes = styles();

    const { tableKey } = useParams<{ tableKey?: string }>()
    const history = useHistory();

    const serviceClient = useServiceClient();
    const [ preferences, setPreferences ] = usePreferences();

    React.useEffect(() => {
        if (!tableKey && !!preferences.tableId) {
            history.replace(`/data-access/table/${preferences.tableId}`);
        }
    }, [ tableKey, preferences ]);
    React.useEffect(() => {
        if (!tableKey)
            return;

        setPreferences(prev => ({
            ...prev,
            tableId: tableKey
        }));
    }, [ tableKey ]);

    const [ availableTables, setAvailableTables ] = React.useState<CatalogEntry[]>([]);
    React.useEffect(() => {(async () => {
        const tables = await serviceClient.getCatalogTables();

        setAvailableTables(tables);
    })()}, [ serviceClient ]);

    const [ table, setTable ] = React.useState<unknown>();
    React.useEffect(() => {(async () => {
        if (!tableKey)
            return;

        const catalogEntity = availableTables.find(e => e.key === tableKey);
        if (!catalogEntity)
            return;

        const table = await serviceClient.getTable(catalogEntity.name);

        setTable(table);
    })()}, [ serviceClient, tableKey, availableTables ]);

    const onSelectedTableChange = (e: React.ChangeEvent<{ value: string }>) => {
        history.push(`/data-access/table/${e.target.value}`);
    }

    return (
        <div className={classes.root}>
            <FormControl className={classes.formControl}>
                <InputLabel id="entity-name-label">Table Name</InputLabel>
                <Select labelId="entity-name-label" id="entity-name-select" value={tableKey || ''} onChange={onSelectedTableChange}>
                    {availableTables.map(entity => <MenuItem value={entity.key}>{entity.displayName}</MenuItem>)}
                </Select>
            </FormControl>

            {table && <TextField
                inputProps={{ className: classes.textarea }}
                disabled
                fullWidth
                variant="outlined"
                label="Raw Entity"
                InputLabelProps={{ shrink: true }}
                margin="dense"
                multiline
                rows={20}
                value={JSON.stringify(table, null, 2)}
            />}
        </div>
    );
}